export const ALPHABET_LIST = [
  'a',
  'b',
  'c',
  'd',
  'e',
  'f',
  'g',
  'h',
  'i',
  'j',
  'k',
  'l',
  'm',
  'n',
  'o',
  'p',
  'q',
  'r',
];
export const STEP_STATE = {
  DISABLED: 'disabled',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};
